module.exports = __webpack_public_path__ + "static/media/image-5.1dc9bbb8.png";